export const relay42SiteIds = {
  'en-CA': 1405,
  'fr-CA': 1405,
  'en-AU': 1406,
  'fr-FR': 1424,
  'en-GB': 1395,
};

export const shouldLoadRelay42 = (locale) => {
  switch (locale) {
    case 'en-AU':
    case 'fr-FR':
    case 'en-GB':
    case 'en-CA':
    case 'fr-CA':
      return true;
    default:
      return false;
  }
};
